function bootstrap() {
    let width;

    /*
     * trigger
     */
    function onLoad() {
        width = window.innerWidth;

        /* eslint-disable no-undef */
        header.init();
        giraSlider.init();
        topLink.init();
        customSelect.init();
        gallery.init();
        video.init();
    }

    function onResizeAndOrientationchange() {
        jQuery(window).on('resize orientationchange', () => {
            if (width !== window.innerWidth) {
                width = window.innerWidth;
            }
        });
    }

    /*
     * load trigger
     */
    jQuery(document).ready(() => {
        onLoad();
        onResizeAndOrientationchange();
    });
}

bootstrap();
